import React from 'react';
import cx from 'classnames';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import style from './style.module.scss';

interface Props {
  subtitle?: string | React.ReactNode;
  supertitle: string;
  supertitleIcon: any;
  title: string | React.ReactNode;
}

export default (props: Props) => (
  <div className={cx(style.restrictedWidthSectionHeader, 'd-flex flex-column flex-none gap-s')}>
    <div className="align-items-center d-flex gap-xs">
      <FontAwesomeIcon icon={props.supertitleIcon} className="text-secondary" />

      <div className="text-secondary" style={{ fontSize: 13 }}>
        <strong>{props.supertitle}</strong>
      </div>
    </div>

    <h2 className="u-margin-A-n"><strong>{props.title}</strong></h2>

    {
      typeof props.subtitle === 'string' ? (
        <div className="small">{props.subtitle}</div>
      ) : props.subtitle
    }
  </div>
);
